module.exports = __webpack_public_path__ + "static/media/coq101.45e7d94d.pdf";